import React from 'react';

const IconOdnok = () => {
  return (
    <div>
      <svg
        width="41"
        height="40"
        viewBox="0 0 41 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.161804" width="40" height="40" rx="8" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5463 25.6628C16.5534 25.4322 15.6278 25.0988 14.7481 24.6461C14.4331 24.4833 14.1229 24.309 13.8219 24.1218C12.9343 23.5676 12.6584 22.4242 13.1918 21.5445C13.7406 20.641 14.8778 20.3473 15.7856 20.8979C16.6788 21.4381 17.6252 21.8308 18.6535 22.0162C20.6772 22.3795 22.5785 22.0449 24.3501 21.0031C24.7117 20.7902 25.0769 20.6232 25.5082 20.6257C26.3444 20.6306 27.0767 21.1658 27.3195 21.9617C27.5636 22.7637 27.2596 23.6318 26.5493 24.0888C25.4427 24.8008 24.2443 25.3025 22.9682 25.6169C22.9131 25.6298 22.8593 25.6457 22.7822 25.6659C22.8342 25.7221 22.8746 25.7662 22.9174 25.809C24.0516 26.9432 25.1864 28.0755 26.3193 29.2115C26.9819 29.8759 27.1213 30.7874 26.6815 31.5472C26.0483 32.6416 24.5924 32.8233 23.6802 31.9167C22.5497 30.7923 21.4253 29.663 20.2991 28.5368C20.2587 28.4964 20.2208 28.453 20.1309 28.3551C20.0936 28.4218 20.0734 28.4866 20.0318 28.5282C18.9031 29.6612 17.7744 30.7923 16.6409 31.9204C15.8633 32.6961 14.6759 32.6912 13.9235 31.9179C13.2353 31.2107 13.2157 30.0876 13.8813 29.3455C13.9712 29.244 14.0691 29.1485 14.1645 29.0525C15.2473 27.9691 16.3295 26.8875 17.4123 25.8035C17.4496 25.7656 17.4881 25.7234 17.5463 25.6628Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1649 7.5C23.7161 7.5 26.6133 10.3985 26.6127 13.9497C26.6121 17.5051 23.7424 20.3993 20.1673 20.4005C16.5721 20.4042 13.7171 17.5058 13.7116 13.9619C13.7054 10.4058 16.5825 7.50979 20.1649 7.5ZM22.8303 13.9558C22.8315 12.4864 21.6429 11.2879 20.1808 11.2843C18.6991 11.2806 17.4922 12.4686 17.4897 13.9319C17.4873 15.3977 18.6759 16.6181 20.1104 16.6193C21.6306 16.6206 22.829 15.4472 22.8303 13.9558Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default IconOdnok;
